import { render, staticRenderFns } from "./CoFileSelect.vue?vue&type=template&id=02bb1c6e&scoped=true&"
import script from "./CoFileSelect.vue?vue&type=script&lang=ts&"
export * from "./CoFileSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CoFileSelect.vue?vue&type=style&index=0&id=02bb1c6e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bb1c6e",
  null
  
)

export default component.exports